import React, { ReactNode, useEffect, useMemo, useState } from "react";
import { useBaselineFilter } from "../../../state/FilterContext";
import { useArrayContext } from "../../../state/ArrayContext";
import { TextExtractor, findFirstComponentOfType } from "../../internal/TextExtractor";

interface BaselinePropertyFilterValuesProps {
    parentBaselineProp?: string | null,
    children?: ReactNode,
}

/***
 * Array source that returns the values of the validity filter.
 */
export const BaselinePropertyFilterValues = React.memo(function BaselinePropertyFilterValues({ parentBaselineProp: parentBaselineArg, children }: BaselinePropertyFilterValuesProps): React.ReactElement {
    const { setArray } = useArrayContext();
    const baseline: string = useBaselineFilter();

    // Get parent validity from the validity child unless it was provided as a prop
    const [parentBaseline, setParentBaseline] = useState<string | null>(null);
    const baselineChild = useMemo(() => parentBaselineArg ? null : findFirstComponentOfType(children, "arg-baseline"), [children, parentBaselineArg]);

    useEffect(() => {
        const usedParentBaseline = parentBaselineArg ?? parentBaseline;
        let value = "";
        if (usedParentBaseline !== null) {
            if (baseline) {
                if (baseline === usedParentBaseline) {
                    value = "";
                }
                else if (usedParentBaseline && baseline.startsWith(usedParentBaseline + ":")) {
                    value = baseline.substring(usedParentBaseline.length + 1);
                }
                else {
                    value = baseline;
                }
            }
            const endDelimiter = value.indexOf(":");
            if (endDelimiter !== -1) {
                value = value.substring(0, endDelimiter);
            }

            setArray([{
                value: value,
                props: {},
                position: 1,
            }]);
        }
    }, [baseline, setArray, parentBaseline, parentBaselineArg]);

    return <>
        <TextExtractor onExtractedText={setParentBaseline}>
            {baselineChild?.props.children}
        </TextExtractor>
    </>;
});